import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import CssBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import AllowedNetworkWrapper from "src/components/Wrapper/AllowedNetworkWrapper";
import AuthorizationWrapper from "src/components/Wrapper/AuthorizationWrapper";
import { FS, NETWORK } from "src/config/constants";
import { getNetworkTokens } from "src/config/tokens";
import { useConfigContext } from "src/context/config/configContext";
import PoolMonitoringProvider, { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import useQueryUrl from "src/hooks/useQueryUrl";
import { CHAIN_ALIASES } from "src/wallet-connection/chains";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";
import AddAsset from "./AddAsset";
import Overview from "./Overview";
import PendingRequest from "./PendingRequest";

function PoolMonitoringLayout() {
  const { pool } = useLowerAddressParam();
  const { action } = useQueryUrl();
  const history = useHistory();
  const { address } = useWeb3Connect();
  const [isLoading, setIsLoading] = useState(true);
  const { chain } = useWeb3Connect();
  const { getAddresses, fetchingAddress } = useConfigContext();
  const { data, fetchingDataStatus, fetchPoolData } = usePoolMonitoringContext();

  useEffect(() => {
    setIsLoading(true);
    if (fetchingDataStatus === FS.SUCCESS) {
      const addresses = Object.keys(data);
      if (addresses.length > 0) {
        if (!pool) history.push(`/pool-monitoring/${addresses[0]}`);
        else if (!addresses.includes(pool)) history.push(`/pool-monitoring/${addresses[0]}`);
      } else history.push("/pool-monitoring");
      setIsLoading(false);
    }
  }, [data, pool, fetchingDataStatus]);

  useEffect(() => {
    if (fetchingAddress === FS.INITIAL) getAddresses();
  }, [fetchingAddress, getAddresses]);

  useEffect(() => {
    if (fetchingDataStatus === FS.SUCCESS) return;
    else if (fetchingAddress === FS.SUCCESS) fetchPoolData();
  }, [fetchingDataStatus, fetchingAddress, fetchPoolData]);

  useEffect(() => {
    fetchPoolData();
  }, [address]);

  const tokens = useMemo(() => {
    if (chain.chainId === CHAIN_ALIASES.BSC_MAINNET) return getNetworkTokens(NETWORK.BSC_MAINNET);
    else if (chain.chainId === CHAIN_ALIASES.BSC_TESTNET) return getNetworkTokens(NETWORK.BSC_TESTNET);
  }, [chain.chainId]);

  return isLoading ? (
    <Box>
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Typography variant="h5" style={{ margin: "auto 0", fontWeight: "bold" }}>
        Pool Monitoring
      </Typography>
      <Typography color="textSecondary" style={{ marginLeft: 0 }}>
        Only Pool Owner
      </Typography>
      {(!action || action == "overview") && <Overview />}
      {action == "add-asset" && <AddAsset />}
      {action == "pending" && <PendingRequest tokens={tokens} />}
    </>
  );
}

export default function PoolMonitoring() {
  const { pool } = useLowerAddressParam();
  const { action } = useQueryUrl();

  function BreadcrumbConfig() {
    const config = [{ text: "analytics" }, { text: "pool monitoring", link: `/pool-monitoring/${pool}` }];
    if (action == "add-asset") {
      config.push({ text: "add asset", link: `/pool-monitoring/${pool}?action=add-asset` });
    }
    return config;
  }

  return (
    <PoolMonitoringProvider>
      <AllowedNetworkWrapper
        allowedNetworks={[CHAIN_ALIASES.BSC_MAINNET, CHAIN_ALIASES.BSC_TESTNET]}
        helperText="Please switch BSC Network"
      >
        <CssBreadcrumb mb={1} config={BreadcrumbConfig()} />
        <AuthorizationWrapper>
          <PoolMonitoringLayout />
        </AuthorizationWrapper>
      </AllowedNetworkWrapper>
    </PoolMonitoringProvider>
  );
}
